<template>
	<div id="page">

		<Header></Header>

		<div id="banner" class="pcShow" :style="'background: url(/static/case_banner'+id+'.jpg) no-repeat;background-position: top center'">
			<div class="txt">
				<h2>{{ this.current_product_category.sname }}</h2>
				<p>{{ this.current_product_category.sdname }}</p>
			</div>
		</div>

		<div class="mobileShow mobileBanner">
			<img :src="'/static/mobile_case_banner'+id+'.jpg'" style="width: 100%;">
			<div class="txt">
				<h2>{{ this.current_product_category.sname }}</h2>
				<p>{{ this.current_product_category.sdname }}</p>
			</div>
		</div>

		<div id="case">
			<div class="container">
				<div class="title">客户案例</div>
			</div>

			<div class="productList productList2">
				<div class="container pcProductList">
					<h2>{{ this.current_product_category.cname }}</h2>
					<div class="swiper-container swiper-container-case-1 ">
						<ul class="swiper-wrapper">
							<li class="swiper-slide" v-for="(item, index) in this.products" :data-index="index">
								<div class="img" v-if="!isIE">
									<a data-fancybox="gallery" :href="imgPrefix+item.product_s_img">
										<img :src="imgPrefix + item.product_s_img" width="336" height="269">
									</a>
								</div>
								<div class="img" v-if="isIE">
									<img :src="imgPrefix + item.product_s_img" width="336" height="269">
								</div>
							</li>
						</ul>

						<div class="swiper-button-next swiper-button-next-case-1" v-if="this.products.length > 8"></div>
						<div class="swiper-button-prev swiper-button-prev-case-1" v-if="this.products.length > 8"></div>
						<div class="swiper-pagination swiper-pagination-case-1" v-if="this.products.length > 8"></div>
					</div>
				</div>

				<!--手机端 S-->
				<div class="mobileProductList">
					<h2>{{ this.current_product_category.cname }}</h2>
					<ul>
						<li v-for="(item, index) in this.products" :data-index="index">
							<div class="img">
								<a>
									<img :src="imgPrefix + item.product_s_img" width="250" height="200">
								</a>
							</div>
						</li>
					</ul>
				</div>
				<!--手机端 E-->
			</div>

			<div class="more-case">
				<div class="container">
					<h2>更多产品案例</h2>
					<div class="links">
<!--            <a v-for="item in product_categorys" :key="item.id" v-if="item.cname" :href="'/product/' + item.id + '.html'">{{ item.cname }}案例 ></a>-->
            <router-link v-for="item in product_categorys" :to="'/product/' + item.id + '.html'" :key="item.id" v-if="item.cname">{{ item.cname }}案例 ></router-link>
					</div>
				</div>
			</div>
		</div>

		<Footer></Footer>

	</div>
</template>

<script>
	import Header from '../../components/Header.vue';
	import Footer from '../../components/Footer.vue';
	import Swiper from 'swiper';
	// import fancyBox from 'vue-fancybox';
	import 'swiper/dist/css/swiper.min.css';

  import { getProductCategoryList, getProductList } from '../../axios/api';

	export default {
		data() {
			return{
				isIE:false,
				imgPrefix: process.env.PREFIX_IMG + 'product/',
				pcImgPrefix: process.env.PREFIX_IMG + 'productCategory/',
				product_categorys: [],
				products: [],

				id: this.$route.params.id ? (typeof(this.$route.params.id) === "object" ? 1 : Number(this.$route.params.id)) : 1,
				current_product_category: {},
					}
			},
		
		components: {
			Header,
			Footer
		},

    watch: {
      $route() {
        this.id = this.$route.params.id ? (typeof(this.$route.params.id) === "object" ? 1 : Number(this.$route.params.id)) : 1;

        getProductCategoryList({'filter_params': {'display_state': 1}}).then(response => {
          var responseData = response.data.data.list;

          this.product_categorys = responseData.filter(x => x.id !== this.id)
          this.current_product_category = responseData.find(x => x.id === this.id)
        });

        getProductList({pageSize: 1000, sort: 'product_sort', order: 'asc', filter_params: {'categoryId': this.id, 'product_display': 1}}).then(response => {
          this.products = response.data.data.list;
        });

        setTimeout(function(){
          new Swiper('.swiper-container-case-1', {
            // autoplay: true,
            slidesPerView: 4,
            slidesPerColumn: 2,
            spaceBetween: 10,
            slidesPerGroup: 4,
            nextButton: '.swiper-button-next-case-1',
            prevButton: '.swiper-button-prev-case-1',
            pagination: '.swiper-pagination-case-1',
            paginationClickable: true
          });
        }, 700);

        $("#nav ul li:nth-child(2) a.parent").addClass("router-link-exact-active")
      }
    },
    mounted() {
      getProductCategoryList({'filter_params': {'display_state': 1}}).then(response => {
        var responseData = response.data.data.list;

        this.product_categorys = responseData.filter(x => x.id !== this.id)
        this.current_product_category = responseData.find(x => x.id === this.id)
      });

      getProductList({pageSize: 1000, sort: 'product_sort', order: 'asc', filter_params: {'categoryId': this.id, 'product_display': 1}}).then(response => {
        this.products = response.data.data.list;
      });

      setTimeout(function(){
        new Swiper('.swiper-container-case-1', {
          // autoplay: true,
          slidesPerView: 4,
          slidesPerColumn: 2,
          spaceBetween: 10,
          slidesPerGroup: 4,
          nextButton: '.swiper-button-next-case-1',
          prevButton: '.swiper-button-prev-case-1',
          pagination: '.swiper-pagination-case-1',
          paginationClickable: true
        });
      }, 700);

      $("#nav ul li:nth-child(2) a.parent").addClass("router-link-exact-active");
	  
	  if(navigator.appName == "Microsoft Internet Explorer"&&parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g, "").replace("MSIE",""))<10){
	     this.isIE = true;
	   }
	  
	  
		},
		methods: {

		}
	}
</script>

<style>
	.swiper-pagination .swiper-pagination-bullet{
		width: 12px !important;
		height: 12px !important;
		margin: 0 7px !important;
	}
</style>
<style scoped="">
	a{
		outline: none;
	}
	#banner {
		height: 515px;
		background: url('https://img.ds-cy.com/static/case_banner.jpg') no-repeat;
		background-position: top center;
		position: relative;
	}

	#banner .txt{
		text-align: center;
		position: absolute;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
	}

	#banner .txt h2{
		color: #fff;
		font-size: 78px;
		margin-bottom: 15px;
	}

	#banner .txt p{
		color: #fff;
		font-size: 30px;
	}

	#case {
		min-height: 500px;
		overflow: hidden;
		padding: 50px 0 20px 0;
	}

	#case .title {
		text-align: center;
		color: #333333;
		font-size: 42px;
		letter-spacing: 2px;
		margin-bottom: 55px;
	}

	.productList {
		min-height: 0;
		overflow: hidden;
	}

	.productList .swiper-container{
		padding-bottom: 50px;
	}

	.productList h2 {
		border-left: 4px solid #00a0e9;
		padding-left: 17px;
		font-size: 40px;
		color: #333333;
		height: 42px;
		line-height: 42px;
		margin-bottom: 25px;
		margin-left: 8px;
	}

	.productList ul li {
		float: left;
		max-width: 335px;
		/* margin-bottom: 0.6666%; */
	}

	.productList ul li:nth-child(4n) {
		margin-right: 0;
	}

	.productList ul li img {
		width: 100%;
		height: auto;
	}

	.productList2 {
		background: #fff;

	}

	.more-case {
		text-align: center;
		margin: 90px auto;
	}

	.more-case h2 {
		text-align: center;
		font-size: 40px;
		color: #333333;
		margin-bottom: 43px;
	}

	.more-case a {
		display: inline-block;
		width: 225px;
		border: 1px solid #dddddd;
		line-height: 62px;
		text-align: center;
		font-size: 22px;
		color: #666666;
		text-decoration: none;
		margin: 10px 20px;
	}

	.more-case a:hover{
		/* background: #00a0e9; */
		color: #00a0e9;
		border: 1px solid #00a0e9;
	}

	.productList .swiper-button-next{
		width: 27px !important;
		height: 76px !important;
		outline: none;
		background: url(../../../static/case-swiper-btn.png);
		right: 0;
		transform: rotate(180deg);
		background-size: 27px 76px !important;
		margin-top: -62px !important;
	}



	.productList .swiper-button-prev{
		width: 27px !important;
		height: 76px !important;
		outline: none;
		background: url(../../../static/case-swiper-btn.png);
		left: 0;
		background-size: 27px 76px !important;
		margin-top: -62px !important;
	}

	.mobileProductList{
		padding-left: 15px;
		display: none;
	}

	.mobileProductList ul li{
		width: 250px;
		display: inline-block;
		white-space: initial;
		margin-right: 5px;
		float: inherit;
	}

	.mobileProductList ul{
		white-space: nowrap;
		overflow-x: scroll;
		-webkit-overflow-scrolling: touch;
		width: 100%;
	}

	.mobileProductList ul li img{
		width: 100%;
	}

	.mobileBanner{
		position: relative;
	}

	.mobileBanner .txt{
		text-align: center;
		position: absolute;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		width: 100%;
	}

	.mobileBanner .txt h2{
		color: #fff;
		font-size: 34px;
	}

	.mobileBanner .txt p{
		color: #fff;
	}

	@media (max-width:991px) {
		
		.pcProductList{
			display: none;
		}
		.mobileProductList{
			display: block;
		}
		.productList2{
			margin-top: 15px;
			background: #f4f4f4;
			padding: 25px 0;
		}
		.productList ul li:nth-child(4n) {
			margin-right: 5px;
		}
		#case .title{
			margin-bottom: 40px;
		}
		#banner .txt h2{
			font-size: 60px;
		}
		#banner .txt p{
			font-size: 28px;
		}
		.more-case a{
			width: 180px;
			line-height: 55px;
			font-size: 18px;
			margin: 10px 15px;
		}
		.more-case{
			margin-top: 60px;
		}
	}


	@media (max-width:767px) {
		

		#case .title{
			font-size: 28px;
			margin-bottom: 0;
		}
		#case{
			padding-top: 30px;
		}
		.productList h2{
		    border-left: 3px solid #00a0e9;
		    padding-left: 12px;
		    font-size: 24px;
		    height: 24px;
		    line-height: 24px;
		    margin-bottom: 20px;
		    margin-left: 0;
		}
		.more-case{
		    margin: 30px auto 18px auto;
			min-height: 0;
			overflow: hidden;
		}
		.more-case a{
		    display: block;
		    width: 31.2%;
		    line-height: 38px;
		    font-size: 13px;
		    margin: 0;
		    float: left;
			margin-right: 3.1%;
		}
		.more-case h2{
			font-size: 26px;
			margin-bottom: 30px;
		}
		.more-case a:last-child{
			margin-right: 0;
		}
		.more-case .links{
			white-space: nowrap;
			overflow-x: scroll;
			width: 100%;
		}
		.more-case .container{
			padding-right: 0;
		}
		.more-case .links a{
			display: inline-block;
			white-space: initial;
			float: inherit;
			width: 135px;
			margin-right: 9px;
		}
		.more-case h2{
			text-indent: -7.5px;
		}
		
	}
</style>



// WEBPACK FOOTER //
// src/page/product/_id.vue